import React, { useEffect, useState } from "react";
import { RefreshCw, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { kindOf, dirColor, FlowBar } from "./tv/TvEarningsFlow";

export const EarningsFlowBoard = () => {
  const [e, setE] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/earnings-flow").then((r) => setE(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const rescan = async () => {
    setBusy(true);
    try { await api.post("/earnings-flow/run", null, { params: { execute: false }, timeout: 120000 }); await load(); toast.success("Earnings flow rescanned"); }
    catch (err) { toast.error("Rescan failed"); }
    setBusy(false);
  };
  const b = (e?.board || []).filter((r) => r.kind !== "error");
  return (
    <div className="bg-[#060b18] border border-[#10F5A033] rounded-2xl p-4" data-testid="earnings-flow-board">
      <div className="flex items-center justify-between mb-3">
        <div>
          <p className="nx-mono text-[10px] tracking-[0.3em] text-[#10F5A0]">EARNINGS × UNUSUAL FLOW</p>
          <p className="text-xs text-cyan-200/50">Directional ≥{e?.min_confidence ?? 70}% goes to the AV Trading v3 floor + Hercules 2.0 · {e?.at ? `scanned ${new Date(e.at).toLocaleString()}` : "no scan yet"}</p>
        </div>
        <button onClick={rescan} disabled={busy} data-testid="earnings-flow-rescan" className="px-3 py-1.5 rounded-lg border border-cyan-300/30 text-cyan-100 text-xs flex items-center gap-1">
          {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <RefreshCw className="w-3.5 h-3.5" />} Rescan
        </button>
      </div>
      <div className="space-y-1.5">
        {b.map((r) => {
          const k = kindOf(r);
          return (
            <div key={r.ticker} className={`grid grid-cols-[4.5rem_6.5rem_1fr_3.5rem] sm:grid-cols-[5rem_7rem_9rem_1fr_4rem] items-center gap-2 rounded-lg px-2 py-1.5 border ${r.qualifies ? "border-emerald-400/40 bg-emerald-400/5" : "border-white/5"}`} data-testid={`earnings-row-${r.ticker}`}>
              <b className="text-cyan-50 nx-mono">{r.ticker}</b>
              <span className="nx-mono text-[10px] font-bold tracking-widest" style={{ color: k.color }}>{k.label}{r.kind === "directional" && <span style={{ color: dirColor(r) }}> {r.direction === "short" ? "▼" : "▲"}</span>}</span>
              <span className="hidden sm:block nx-mono text-[10px] text-cyan-200/50 truncate">{r.report}</span>
              {r.total > 0 ? <FlowBar r={r} h="h-2" /> : <span className="text-[10px] text-cyan-200/30">no flow</span>}
              <span className="nx-mono text-sm font-black text-right" style={{ color: r.qualifies ? dirColor(r) : "#94A3B8" }} data-testid={`earnings-conf-${r.ticker}`}>{Math.round(r.confidence || 0)}%</span>
            </div>
          );
        })}
        {!b.length && <p className="text-sm text-cyan-200/40">No earnings flow scan yet — tap Rescan.</p>}
      </div>
    </div>
  );
};
